import React from 'react';

const User = (props) => {
  return <div className="bg-background p-4 w-screen h-screen">User Screen</div>;
};

export default User;
